import { render, staticRenderFns } from "./RefsTicket.vue?vue&type=template&id=1ce195d7&scoped=true"
import script from "./RefsTicket.vue?vue&type=script&lang=ts"
export * from "./RefsTicket.vue?vue&type=script&lang=ts"
import style0 from "./RefsTicket.vue?vue&type=style&index=0&id=1ce195d7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce195d7",
  null
  
)

export default component.exports